import { useEffect, useState } from "react";
import SwapHeader from "../SwapHeader";

import "../swap-component.css";
import { InputComponent } from "../../common/input/InputComponent";
import SwapRate from "../SwapRate";
import CommonButton from "../../common/buttons/CommonButton";
import { walletState } from "../../../context/walletState";
import { swapState } from "../../../context/swapState";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { useConnectWallet } from "../../../hooks/useTxnClient";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightLeft } from "@fortawesome/free-solid-svg-icons";
import SwapPriceInfo from "../SwapPriceInfo";
import { useRoute } from "../../../hooks/useRoute";
import LoadingModal from "../../common/loading-modal/LoadingModal";
import { swapRateState } from "../../../context/swapRateState";

const SwapComponent = () => {
  const { address } = useRecoilValue(walletState);
  const setSwapData = useSetRecoilState(swapState);
  const swapData = useRecoilValue(swapState);
  const connectWallet = useConnectWallet();
  const { doSwap } = useRoute();
  const [token1, setToken1] = useState<string>("sSCRT");
  const [token2, setToken2] = useState<string>("sATOM");
  const [swap, setSwap] = useState<boolean>(true);
  const [priceShow, setPriceShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const swapRateData = useRecoilValue(swapRateState);

  const handleToken1 = (val: any) => {
    setToken1(val);
  };
  const handleToken2 = (val: any) => {
    setToken2(val);
  };
  const handleswitch = () => {
    let temp = token1;
    setToken1(token2);
    setToken2(temp);

    setSwapData({
      ...swapData,
      input1: swapRateData.input2 as string,
    });

    setSwap((p) => !p);
    setTimeout(function () {
      setSwap((p) => !p);
    }, 300);
  };
  const handleSwapClick = async () => {
    setIsLoading(true);
    const swapress =await doSwap(token1, token2, swapData.input1, swapData.slippage);
    // await doSwap(token1, token2, swapData.input1, "0.05");
    setSwapData({
      ...swapData,
      input1: "",
    });
    setIsLoading(false);
  };  

  const disabledcoin1 = token1;
  const disabledcoin2 = token2;
  const [token1Bal, settoken1Bal] = useState(0);

  return (
    <div className="swap-wrapper">
      <div className="swap-container">
        <SwapHeader />
        <InputComponent
          className={
            swap ? "in-animate1" : "input-component-container-swap1 in-animate1"
          }
          isOutput={false}
          coinName={token1}
          coinSelect={(tok) => handleToken1(tok)}
          disabledcoin={disabledcoin2}
          settoken1bal={settoken1Bal}
          isLoading={isLoading}
        />
        <div className="iconDiv">
          <div className="iconContainer" onClick={() => handleswitch()}>
            <FontAwesomeIcon className="arrowIcon" icon={faRightLeft} />
          </div>
        </div>
        <InputComponent
          className={
            swap ? "in-animate2" : "input-component-container-swap2 in-animate2"
          }
          isOutput={true}
          coinName={token2}
          coinSelect={(tok) => handleToken2(tok)}
          disabledcoin={disabledcoin1}
          isLoading = {isLoading}
        />
        <SwapRate denom1={token1} denom2={token2} />
        <CommonButton
          customClass={
            (Number(swapData.input1) !== 0 &&
              Number(swapData.input1) <= Number(token1Bal)) ||
            !address
              ? ""
              : "disabled-button"
          }
          name={
            address
              ? swapData.input1 === ""
                ? "Swap"
                : Number(swapData.input1) === 0
                ? "Input is Zero"
                : !(Number(swapData.input1) <= Number(token1Bal))
                ? "Insufficient Balance"
                : "Swap"
              : "CONNECT WALLET"
          }
          onClick={
            address
              ? Number(swapData.input1) !== 0 &&
                Number(swapData.input1) <= Number(token1Bal)
                ? handleSwapClick
                : () => {}
              : () => connectWallet()
          }
          extLink={false}
        />
      </div>
      {swapData.input1 ? (
        <SwapPriceInfo denom1={token1} denom2={token2} />
      ) : (
        <></>
      )}
      <LoadingModal
        content={["Swapping", `${swapData.input1} ${token1} for ${token2}`]}
        isOpen={isLoading}
      />
    </div>
  );
};

export default SwapComponent;
